import { useEffect, useRef } from 'react'

// Los lectores de código de barras HID se comportan como teclados:
// escriben los dígitos muy rápido (<50ms entre teclas) y terminan con Enter.
// Un humano escribe más lento. Usamos eso para distinguirlos.

const INTERVALO_MAX_MS = 50  // tiempo máximo entre teclas del lector
const MIN_LARGO = 4          // mínimo de caracteres para ser un código

export function useEscanerHID(onCodigo, habilitado = true) {
  const bufferRef = useRef('')
  const ultimaTeclaRef = useRef(0)
  const timerRef = useRef(null)

  useEffect(() => {
    if (!habilitado) return

    function handleKeyDown(e) {
      // Si el foco está en un input/textarea, no interceptar
      const tag = document.activeElement?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return

      const ahora = Date.now()
      const intervalo = ahora - ultimaTeclaRef.current
      ultimaTeclaRef.current = ahora

      // Enter = fin del código
      if (e.key === 'Enter') {
        const codigo = bufferRef.current.trim()
        if (codigo.length >= MIN_LARGO) {
          onCodigo(codigo)
        }
        bufferRef.current = ''
        clearTimeout(timerRef.current)
        return
      }

      // Solo acumular caracteres imprimibles
      if (e.key.length !== 1) return

      // Si el intervalo fue muy largo, es escritura humana → resetear
      if (bufferRef.current && intervalo > INTERVALO_MAX_MS * 3) {
        bufferRef.current = ''
      }

      bufferRef.current += e.key

      // Auto-limpiar si no llega Enter (por si el lector no envía Enter)
      clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        bufferRef.current = ''
      }, 300)
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      clearTimeout(timerRef.current)
    }
  }, [onCodigo, habilitado])
}
